<template xmlns:el-col="http://www.w3.org/1999/html">
  <div class="container">
    <el-row :gutter="5" class="class-dish" type="flex">
      <el-card class="box-card" :body-style="{ padding: '10px', height: '300px','overflow-y': 'scroll'}">
        <div slot="header" class="clearfix">
          <h2 class="header-title">标准碗碟库</h2>
          <div class="btn-wrapper-1">
            <el-button type="danger" @click="toSelfCheck">纠错</el-button>
            <el-button type="success" @click="submitMarkedData"
              >标注完成</el-button>
          </div>
        </div>
        <div class="image-wrapper">
          <div v-for="dishModel in modelList" class="item" :key="dishModel.class_id">
            <draggable v-model="markedObject[dishModel.class_id]" class="dragg"
                       :options="{group:'modelList', filter: '.undraggable'}">
              <el-badge :value="markedObject[dishModel.class_id] ? markedObject[dishModel.class_id].length : 0"
                        class="undraggable class-image-wrapper">
                <div class="image-wrapper-1">
                  <img :src="dishModel.dish_image_url" class="image-item"  alt="" />
                </div>
              </el-badge>
            </draggable>
            <div class="dish-wrapper">
              <img :src="dish.dish_img_url" v-for="dish in markedObject[dishModel.class_id]" alt=""
                   :key="dish.dish_image_url"
                   width="20"
                   height="20">
            </div>
        </div>
        </div>
      </el-card>
      <el-card class="box-delete">
        <div slot="header">
          <h2 class="danger-text header-title">回收站</h2>
        </div>
        <draggable v-model="batchImageListDelete" class="dragg"
                   :options="{group:'modelList', filter: '.undraggable', chosenClass: 'chosing'}">
          <div
            class="image-item"
            v-for="dish in batchImageListDelete"
            :key="dish.dish_uuid"
          >
            <el-popover ref="popover1" placement="top-start" trigger="hover">
              <img
                :src="dish.dish_img_url"
                slot="reference"
                alt=""
                width="20px"
                height="20px"
              />
              <div class="big-img-wrapper">
                <el-button type="primary" class="btn" style="position: absolute"
                           @click="unDelete(dish)">撤回
                </el-button>
                <img :src="dish.dish_img_url" alt=""   >
              </div>
            </el-popover>
          </div>
        </draggable>
      </el-card>
      <div class="btn-wrapper">
        <!-- <el-button type="primary" @click="saveLocal">保存</el-button> -->
      </div>
    </el-row>
    <h2 class="process-title">
      {{ selfCheck ? "3. 自查后标注" : "1. 初标注" }}: 从下列图片中选择与例图
      <span class="strong-text">相符的碗碟</span>拖动标记, 无效图片请拖至回收站
      <div class="tag-wrapper">
        <el-badge :value="batchImageListMarkedCount" class="item">
          <el-tag type="success">已标记</el-tag>
        </el-badge>
        <el-badge :value="batchImageListUnmarkedCount" class="item">
          <el-tag type="danger">未标记</el-tag>
        </el-badge>
        <el-badge :value="batchImageListDeleteCount" class="item">
          <el-tag type="danger">已删除</el-tag>
        </el-badge>
      </div>
    </h2>
    <imageMarkWrapper
      v-if="batchImageListUnmarkedCount"
      :images="unMarkedImageList"
      current_class_id="1"
    >
    </imageMarkWrapper>
    <h3 class="tip-wrapper" v-else>
      当前批次标注已完成, 如有标记错误请点击<el-button type="danger" @click="toSelfCheck">纠错</el-button>
      , 如无标记错误请点击<el-button type="success" @click="submitMarkedData"
    >标注完成</el-button> 辛苦您啦
    </h3>
  </div>
</template>
<script type="">
import {mapGetters, mapMutations} from 'vuex';
import draggable from 'vuedraggable';

import imageMarkWrapper from '_c/imageMarkWrapper';
import {apiChangeBatchState, apiGetBatchImageList, apiMarkBatchImages, apiQueryCanteenClassList} from '@/api';

export default {
  name: 'markProcess',
  components: {
    imageMarkWrapper,
    draggable
  },
  data () {
    return {
      modelList: [],
      wrongDishList: [],
      testList: [],
      currentIndex: 0,
      markedObject: {},
      batchImageListDelete: []
    };
  },
  mounted () {
    this.getModelList();
    this.setSubTitle('图片标注');
    this.getImagesByBatchTag();
    this.emitLoading();
    setTimeout(() => {
      if (!this.selfCheck) {
        this.wrongImageList();
      }
      this.modelList.forEach(model => {
        this.$set(this.markedObject, model.class_id, this.markImageList.filter((dish) => {
          return dish.class_id === model.class_id;
        }));
      });
      this.batchImageListDelete = this.markImageList.filter((dish) => {
        return dish.class_id === '-1';
      });
      this.removeLoading();
    }, 1000);
  },
  methods: {
    ...mapMutations([
      'setBatchImageList',
      'setBatchTag',
      'setSubTitle',
      'setMarkedImageList',
      'emitLoading',
      'removeLoading',
      'unMark'
    ]),
    async getModelList () {
      try {
        let res = await apiQueryCanteenClassList({ canteenId: this.canteen.canteen_id, apiKey: this.apiKey });
        console.log(res.dish_info_list);
        this.modelList = res.dish_info_list;
      } catch (e) {
        console.log(e);
      };
    },
    wrongImageList () {
      let arr = [];
      if (Array.isArray(this.checkTextObjList)) {
        this.checkTextObjList.forEach(a => {
          let idx = this.$_.findIndex(this.markImageList, function (b) {
            return a.dish_img_uuid === b.dish_img_uuid;
          });
          if (idx !== -1) {
            this.markImageList[idx].class_id = '';
            this.$set(this.markImageList[idx], 'checkText', a.check_text);
          }
        });
      } else if (this.checkTextObjList) {
        this.$message.error(`当前审核意见为: ${this.checkTextObjList}, 格式有误`);
      }
    },
    // handleAdd (target) {
    //   // console.log(a);
    //   // console.log(1);
    //   console.log(target);
    //   // target.className('')
    // },
    // unDelete (dish) {
    //   this.unMa
    // },
    // 保存标记状态到本地
    saveLocal () {},
    toSelfCheck () {
      if (this.batchImageListUnmarkedCount > 0) {
        this.$alert('标注还未完成, 请继续标注', '', {
          confirmButtonText: '确定'
        });
      } else {
        this.setMarkedImageList(this.markedListFlatten);
        this.$router.push({
          anme: 'checkProcess',
          params: {
            batch_tag: this.batch_tag,
            selfCheck: true
          }
        });
      }
    },
    // 查询批次图片
    async getImagesByBatchTag () {
      if (this.selfCheck === true) {
        // 自查返回
      } else {
        let res = await apiGetBatchImageList({
          canteen_id: this.canteen.canteen_id,
          batch: this.batch_tag,
          apiKey: this.apiKey
        });
        this.setBatchImageList(res);
      }
    },
    // 下一个例图
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    async submitMarkedData () {
      if (this.batchImageListUnmarkedCount > 0) {
        this.$alert('标注还未完成, 请继续标注', '', {
          confirmButtonText: '确定'
        });
      } else {
        this.setMarkedImageList(this.markedListFlatten);
        await apiMarkBatchImages({
          apiKey: this.apiKey,
          canteen_id: this.canteen.canteen_id,
          label_info_list: this.markedListFlatten,
          batch: this.batch_tag
        });
        await apiChangeBatchState({
          system_id: 1,
          batch_tag: this.batch_tag,
          batch_state: 2,
          apiKey: this.apiKey
        });
        this.setBatchTag('');
        this.$router.push('/dataMark/batchList');
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentDishModelIndex',
      'listQuery',
      'userinfo'
    ]),
    canteen () {
      if (this.$route.query && this.$route.query.canteen) {
        return this.$route.query.canteen;
      } else {
        return this.listQuery.canteen;
      }
    },
    checkTextObjList () {
      return this.$route.query && this.$route.query.checkTextObj;
    },
    selfCheck () {
      return this.$route.query.selfCheck || false;
    },
    apiKey () {
      return this.$store.getters.userinfo().api_key;
    },
    batch_tag () {
      return this.$store.getters.batchTag;
    },
    markImageList () {
      return this.$store.getters.markImageList();
    },
    unMarkedImageList () {
      // return this.markImageList;
      return this.markImageList.filter((dish) => {
        // return !dish.class_id;
        if (dish.class_id === -1) {
          return false;
        }
        let idx = this.$_.findIndex(this.modelList, function (model) {
          return model.class_id === dish.class_id;
        });
        return idx === -1;
      });
    },
    batchImageListUnmarkedCount () {
      return this.markImageList.length - this.batchImageListMarkedCount - this.batchImageListDeleteCount;
    },
    batchImageListMarkedCount () {
      return this.markedListFlatten.length - this.batchImageListDeleteCount;
    },
    batchImageListDeleteCount () {
      return this.batchImageListDelete && this.batchImageListDelete.length;
    },
    // batchImageListDelete () {
    //   return this.markImageList.filter(image => {
    //     return image.class_id === '-1';
    //   });
    // },
    // batchImagesBlongCurrentModel () {
    //   return this.markImageList.filter(image => {
    //     return image.class_id === this.currentDishModel.class_id;
    //   });
    // },
    // imageMarkedCount () {
    //   return (
    //     -this.batchImageListUnmarked.length -
    //     this.batchImageListDelete.length +
    //     this.markImageList.length
    //   );
    // },
    // 已标注的列表
    markedListFlatten () {
      let markedListArray = Object.values(this.markedObject);
      let markedListClassIdList = Object.keys(this.markedObject);
      markedListArray.forEach((markedList, index) => {
        markedList.forEach(dish => {
          dish.class_id = markedListClassIdList[index];
        });
      });
      this.batchImageListDelete.forEach((_model) => {
        _model.class_id = '-1';
      });
      return [...this.$_.flatten(markedListArray), ...this.batchImageListDelete];
    }
  },
  watch: {
    currentDishModelIndex () {}
  }
};
</script>
<style scoped lang="scss">
.container {
  .header-title {
    display: inline-block;
  }
  .tip-wrapper {
    display: inline-block;
    width: auto;
    padding: 20px;
    border: 2px solid red;
    border-radius: 20px;
  }
  .process-title {
    .strong-text {
      color: #65c13e;
    }
    .tag-wrapper {
      padding-left: 10px;
      display: inline-block;
    }
  }
  .box-card {
    width: 90%;
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
  }
  .image-wrapper {
    display: inline-block;
    vertical-align: top;
    .item {
      display: inline-block;
      vertical-align: top;
      width: 120px;
      margin: 0 5px;
      min-height: 120px;
      text-align: center;
      border: 2px solid #ccc;
      .class-image-wrapper{
        width: 100px;
      }
      .dish-wrapper {
        padding-top: 5px;
      }
      .dragg {
        .chosing {
          background-color: red;
        }
        .image-wrapper-1 {
          width: 100px;
          height: 100px;
          .image-item {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
  }
  .box-delete {
    .dragg {
      width: 100px;
      min-height: 250px;
      .image-item {
        display: inline-block;
      }
    }
  }
}
</style>
